import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

export const BackgroundContainer = styled(Box)(({ theme }) => ({
    minHeight: '200px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    marginTop: '-30px',
    overflow: 'hidden',

    [theme.breakpoints.down('lg')]: {
        minHeight: '300px',
    },
    [theme.breakpoints.down('md')]: {
        minHeight: '280px',
        marginTop: '-60px',
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        marginTop: '0',
        minHeight: '350px',
        padding: '20px',
    },
}));

export const HeaderText = styled(Typography)(({ theme }) => ({
    fontSize: '3rem',
    fontWeight: 'bold',
    color: '#2c3e50',
    textAlign: 'center',
    marginTop: '30px',

    [theme.breakpoints.down('lg')]: {
        fontSize: '2.5rem',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2rem',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.6rem',
        marginTop: '20px',
    },
}));

export const SearchBarContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
    width: '100%',
    backgroundColor: '#fff',
    padding: '8px 12px 4px',
    borderRadius: '16px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',

    [theme.breakpoints.down('md')]: {
        width: '95%',
        padding: '6px 10px',
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: '12px',
        marginTop: '20px',
        width: '100%',
        padding: '10px',
    },
}));

export const SearchButton = styled(Button)(({ theme }) => ({
    marginLeft: '16px',
    backgroundColor: '#002F87',
    color: '#fff',
    borderRadius: '12px',
    height: '100%',
    padding: '10px 24px',
    boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.15)',
    '&:hover': {
        backgroundColor: '#001B5E',
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    [theme.breakpoints.down('md')]: {
        padding: '8px 18px',
    },
    [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        width: '100%',
        padding: '10px',
    },
}));

export const ScaleComputingSection = styled(Box)(({ theme }) => ({
    width: '80%',
    margin: '0 auto 20px',
    height: '310px',
    [theme.breakpoints.down('md')]: { width: '90%', marginBottom: '30px', height: '310px' },
    [theme.breakpoints.down('sm')]: { width: '100%', marginBottom: '20px', padding: '10px', height: '310px' },
}));


export const BestSellerSection = styled(Box)(({ theme }) => ({
    width: '80%',
    margin: '0 auto',
    paddingBottom: '40px',
    [theme.breakpoints.down('md')]: { 
        width: '90%',
        paddingBottom: '30px',
    },
    [theme.breakpoints.down('sm')]: { 
        width: '100%', 
        padding: '10px',
        paddingBottom: '20px',
    },
}));

export const BottomSectionContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '20px 0',

    [theme.breakpoints.down('md')]: {
        padding: '15px 0',
    },
    [theme.breakpoints.down('sm')]: {
        padding: '10px 0',
    },
}));
